import { FuseNavigationItem } from '@fuse/components/navigation';
import { USER_ROLES } from 'common/constants/user-role.constants';
import { CheckReportAccess } from './accessCheckers';

export const lsrNavigation: FuseNavigationItem[] = [
    {
        id: 'electronic-id-requests',
        type: 'collapsable',
        children: [
            {
                id: 'electronic-id-requests.send-request',
                type: 'basic',
                link: '/rafraen-audkenning/senda-audkenningarbeidni',
                meta: {
                    roles: [USER_ROLES.SEND_ELECTRONIC_ID_REQUESTS],
                },
            },
            {
                id: 'electronic-id-requests.view-requests',
                type: 'basic',
                link: '/rafraen-audkenning/skoda-audkenningar',
                meta: {
                    roles: [USER_ROLES.SEND_ELECTRONIC_ID_REQUESTS, USER_ROLES.VIEW_ALL_ELECTRONIC_ID_REQUESTS],
                },
            },
        ],
        meta: {
            hide: true,
        },
    },
    {
        id: 'groups',
        type: 'basic',
        link: '/hopar',
        meta: {
            hide: true,
            roles: [USER_ROLES.EDIT_OWN_GROUPS, USER_ROLES.EDIT_SVID_GROUPS],
        },
    },
    {
        id: 'national-registry-company-registry',
        type: 'basic',
        link: '/thjodskra-og-fyrirtaekjaskra',
        meta: {
            hide: true,
            roles: [USER_ROLES.REGISTER_ICELAND_LOOKUP],
        },
    },
    {
        id: 'incidents-and-requests',
        type: 'basic',
        link: '/atvik-og-beidnir/yfirlit',
        meta: {
            hide: true,
            roles: [
                USER_ROLES.SEND_INCIDENT_REPORT,
                USER_ROLES.SEND_TECHNICAL_SUPPORT_REQUESTS,
                USER_ROLES.SEND_ACCESS_REQUESTS,
                USER_ROLES.SEND_HOUSING_REQUESTS,
                USER_ROLES.SEND_EMPLOYEE_SUPPORT_REQUESTS,
            ],
        },
    },
    {
        id: 'currency',
        type: 'collapsable',
        children: [
            {
                id: 'currency.register-currency',
                type: 'basic',
                active: false,
                link: '/gengi/skra-gengi',
            },
            {
                id: 'currency.register-currency-regardless-of-assets',
                type: 'basic',
                active: false,
                link: '/gengi/skra-gengi-ohad',
            },
        ],
        disabled: true,
        meta: {
            hide: true,
            roles: [USER_ROLES.CURRENCY_REGISTER],
        },
    },
    {
        id: 'maelabord-og-skyrslur',
        type: 'collapsable',
        children: [
            {
                id: 'maelabord-og-skyrslur.stjorn',
                type: 'collapsable',
                active: false,
                children: [
                    {
                        id: 'maelabord-og-skyrslur.stjorn.eignasafn',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.stjorn.eignasafn',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.stjorn.eignasafn',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.stjorn.hreyfingarapx',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.stjorn.hreyfingarapx',
                        },
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.stjorn.hreyfingarapx',
                                },
                            ],
                        },
                        exactMatch: true,
                    },
                ],
                disabled: true,
            },
            {
                id: 'maelabord-og-skyrslur.stafraenthroun',
                type: 'collapsable',
                active: false,
                children: [
                    {
                        id: 'maelabord-og-skyrslur.stafraenthroun.umsoknirvillueftirlit',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.stafraenthroun.umsoknirvillueftirlit',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.stafraenthroun.umsoknirvillueftirlit',
                                },
                            ],
                        },
                    },
                ],
                disabled: true,
            },
            {
                id: 'maelabord-og-skyrslur.eignastyring',
                type: 'collapsable',
                active: false,
                children: [
                    {
                        id: 'maelabord-og-skyrslur.eignastyring.eignasafn',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.eignastyring.eignasafn',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.eignastyring.eignasafn',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.eignastyring.gengisskraning',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.eignastyring.gengisskraning',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.eignastyring.gengisskraning',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.eignastyring.eignirlsr',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.eignastyring.eignirlsr',
                        },
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.eignastyring.eignirlsr',
                                },
                            ],
                        },
                        exactMatch: true,
                    },
                    {
                        id: 'maelabord-og-skyrslur.eignastyring.hreyfingarapx',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.eignastyring.hreyfingarapx',
                        },
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.eignastyring.hreyfingarapx',
                                },
                            ],
                        },
                        exactMatch: true,
                    },
                ],
                disabled: true,
            },
            {
                id: 'maelabord-og-skyrslur.fjarmalasvid',
                type: 'collapsable',
                active: false,
                children: [
                    {
                        id: 'maelabord-og-skyrslur.fjarmalasvid.maelikvardarrettindamal',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.fjarmalasvid.maelikvardarrettindamal',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.fjarmalasvid.maelikvardarrettindamal',
                                },
                            ],
                        },
                    },
                ],
                disabled: true,
            },
            {
                id: 'maelabord-og-skyrslur.ahaettustyring',
                type: 'collapsable',
                active: false,
                subtitle: 'Upplýsingar fyrir áhættustýringu',
                children: [
                    {
                        id: 'maelabord-og-skyrslur.ahaettustyring.PEPlisti',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.ahaettustyring.PEPlisti',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.ahaettustyring.PEPlisti',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.ahaettustyring.greidslumat',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.ahaettustyring.greidslumat',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.ahaettustyring.greidslumat',
                                },
                            ],
                        },
                    },
                ],
                disabled: true,
            },
            {
                id: 'maelabord-og-skyrslur.sjalfbaerni',
                type: 'collapsable',
                active: false,
                subtitle: 'Upplýsingar um sjálfbærni innan LSR',
                children: [
                    {
                        id: 'maelabord-og-skyrslur.sjalfbaerni.sjalfbaerniskyrsla',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.sjalfbaerni.sjalfbaerniskyrsla',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.sjalfbaerni.sjalfbaerniskyrsla',
                                },
                            ],
                        },
                    },
                ],
                disabled: true,
            },
            {
                id: 'maelabord-og-skyrslur.lanasvid',
                type: 'collapsable',
                active: false,
                subtitle: 'Upplýsingar fyrir lánasvið',
                children: [
                    {
                        id: 'maelabord-og-skyrslur.lanasvid.peningathvaettisvarnir',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lanasvid.peningathvaettisvarnir',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lanasvid.peningathvaettisvarnir',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lanasvid.peningathvaettisvarnirinnaborganir',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lanasvid.peningathvaettisvarnirinnaborganir',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lanasvid.peningathvaettisvarnirinnaborganir',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lanasvid.talninglansretturbdeild',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lanasvid.talninglansretturbdeild',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lanasvid.talninglansretturbdeild',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lanasvid.endurskodunvaxta',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lanasvid.endurskodunvaxta',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lanasvid.endurskodunvaxta',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lanasvid.verndadirsjodfelagar',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lanasvid.verndadirsjodfelagar',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lanasvid.verndadirsjodfelagar',
                                },
                            ],
                        },
                    },
                ],
                disabled: true,
            },
            {
                id: 'maelabord-og-skyrslur.lifeyrissvid',
                type: 'collapsable',
                active: false,
                children: [
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.abyrgdarhopur',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.abyrgdarhopur',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.abyrgdarhopur',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.aldursgreiningsjodfelaga',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.aldursgreiningsjodfelaga',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.aldursgreiningsjodfelaga',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.email',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.email',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.email',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.stefja415',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.stefja415',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.stefja415',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.villulisti',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.villulisti',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.villulisti',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.fjoldilifeyristhega',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.fjoldilifeyristhega',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.fjoldilifeyristhega',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.opinmakakort',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.opinmakakort',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.opinmakakort',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.ororkuurskurdirbdeild',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.ororkuurskurdirbdeild',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.ororkuurskurdirbdeild',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.tilgreindsereign',
                        type: 'collapsable',
                        active: false,
                        children: [
                            {
                                id: 'maelabord-og-skyrslur.lifeyrissvid.tilgreindsereign.itarleg',
                                type: 'basic',
                                active: false,
                                link: '/maelabord-og-skyrslur',
                                queryParams: {
                                    key: 'maelabord-og-skyrslur.lifeyrissvid.tilgreindsereign.itarleg',
                                },
                                exactMatch: true,
                                meta: {
                                    additionalAccessCheckers: [
                                        {
                                            accessCheckerFunc: CheckReportAccess,
                                            args: 'maelabord-og-skyrslur.lifeyrissvid.tilgreindsereign.itarleg',
                                        },
                                    ],
                                },
                            },
                            {
                                id: 'maelabord-og-skyrslur.lifeyrissvid.tilgreindsereign.einfold',
                                type: 'basic',
                                active: false,
                                link: '/maelabord-og-skyrslur',
                                queryParams: {
                                    key: 'maelabord-og-skyrslur.lifeyrissvid.tilgreindsereign.einfold',
                                },
                                exactMatch: true,
                                meta: {
                                    additionalAccessCheckers: [
                                        {
                                            accessCheckerFunc: CheckReportAccess,
                                            args: 'maelabord-og-skyrslur.lifeyrissvid.tilgreindsereign.einfold',
                                        },
                                    ],
                                },
                            },
                        ],
                        disabled: true,
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.andlatsskjal',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.andlatsskjal',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.andlatsskjal',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.rettindahlutfallmedaltal',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.rettindahlutfallmedaltal',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.rettindahlutfallmedaltal',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.lifsvottordbusettirerlendis',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.lifsvottordbusettirerlendis',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.lifsvottordbusettirerlendis',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.utsendingarlistiabs',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.utsendingarlistiabs',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.utsendingarlistiabs',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.utsendingarlistiendurmat',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.utsendingarlistiendurmat',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.utsendingarlistiendurmat',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.oturskurdir',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.oturskurdir',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.oturskurdir',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.thydifyrirprofanir',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.thydifyrirprofanir',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.thydifyrirprofanir',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.geymdurrettur',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.geymdurrettur',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.geymdurrettur',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.lifeyrissvid.rettindahlutfalluppbot',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.lifeyrissvid.rettindahlutfalluppbot',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.lifeyrissvid.rettindahlutfalluppbot',
                                },
                            ],
                        },
                    },
                ],
                disabled: true,
            },
            {
                id: 'maelabord-og-skyrslur.thjonusta',
                type: 'collapsable',
                active: false,
                children: [
                    {
                        id: 'maelabord-og-skyrslur.thjonusta.thjonustumaelikvardar',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.thjonusta.thjonustumaelikvardar',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.thjonusta.thjonustumaelikvardar',
                                },
                            ],
                        },
                    },
                    {
                        id: 'maelabord-og-skyrslur.thjonusta.thjonustumaelikvardartimasetningar',
                        type: 'basic',
                        active: false,
                        link: '/maelabord-og-skyrslur',
                        queryParams: {
                            key: 'maelabord-og-skyrslur.thjonusta.thjonustumaelikvardartimasetningar',
                        },
                        exactMatch: true,
                        meta: {
                            additionalAccessCheckers: [
                                {
                                    accessCheckerFunc: CheckReportAccess,
                                    args: 'maelabord-og-skyrslur.thjonusta.thjonustumaelikvardartimasetningar',
                                },
                            ],
                        },
                    },
                ],
                disabled: true,
            },
        ],
        disabled: true,
        meta: {
            hide: true,
        },
    },
    {
        id: 'lan',
        type: 'collapsable',
        children: [
            {
                id: 'loans.mortgage-eligibility-form-list',
                type: 'basic',
                active: false,
                link: '/lan/vedhaefi',
                disabled: true,
                meta: {
                    roles: [USER_ROLES.EDIT_MORTGAGE_ELIGIBILITY_FORMS],
                },
            },
            {
                id: 'lan.fme-report',
                type: 'basic',
                active: false,
                link: '/lan/fme-skil',
                disabled: true,
                meta: {
                    hide: true,
                    roles: [USER_ROLES.RISK_MANAGEMENT_FME_REPORT],
                },
            },
        ],
    },
    {
        id: 'pension',
        type: 'collapsable',
        children: [
            {
                id: 'pension.applications.statistics',
                type: 'basic',
                active: false,
                link: '/lifeyrir/umsoknir/tolfraedi',
                disabled: true,
                meta: {
                    hide: true,
                    roles: [USER_ROLES.APPLICATIONS_MANUAL_STATISTICS_ADMIN, USER_ROLES.APPLICATIONS_MANUAL_STATISTICS],
                },
            },
            {
                id: 'pension.applications.other-funds',
                title: 'Umsóknir frá öðrum sjóðum',
                subtitle: 'Skrá umsóknir sem berast frá öðrum sjóðum',
                type: 'basic',
                active: false,
                link: '/lifeyrir/umsoknir/adrir-sjodir',
                meta: {
                    roles: [USER_ROLES.PENSION_OTHER_FUNDS_APPLICATIONS],
                },
            },
            {
                id: 'pension.coefficients',
                type: 'basic',
                active: false,
                link: '/lifeyrir/studlar',
                subtitle: '',
                disabled: true,
                meta: {
                    hide: true,
                    roles: [USER_ROLES.PENSION_COEFFICIENT_MANAGEMENT],
                },
            },
            {
                id: 'pension.state-responsibility-group',
                type: 'basic',
                link: '/lifeyrir/rikisabyrgdarhopur-uppgjor',
                meta: {
                    roles: [USER_ROLES.PENSION_STATE_RESPONSIBILITY_GROUP],
                },
            },
            {
                id: 'pension.increase-claims',
                type: 'basic',
                link: '/lifeyrir/lifeyrishaekkanir',
                meta: {
                    roles: [USER_ROLES.PENSION_INCREASE_CLAIMS],
                },
            },
            {
                id: 'pension.division-rulings',
                type: 'basic',
                link: '/lifeyrir/adgreining-urskurda',
                meta: {
                    roles: [USER_ROLES.PENSION_DIVISION_OF_RULINGS],
                },
            },
            {
                id: 'pension.paycheck-runs',
                type: 'basic',
                link: '/lifeyrir/launasedlavinnslur',
                meta: {
                    hide: true,
                    roles: [USER_ROLES.PENSION_PAYCHECK_RUNS],
                },
            },
            {
                id: 'pension.pending-tax-updates',
                title: 'Skattaupplýsingar í bið',
                type: 'basic',
                link: '/lifeyrir/skattaupplysingar-i-bid',
                meta: {
                    roles: [USER_ROLES.PENSION_INFO],
                },
            },
        ],
    },
    {
        id: 'logs',
        type: 'basic',
        link: '/breytingasaga',
        meta: {
            hide: true,
            roles: [USER_ROLES.EXTERNAL_SYSTEM_LOGS],
        },
    },
    {
        id: 'validation-check',
        type: 'collapsable',
        children: [
            {
                id: 'validation-check.xml-xsd',
                type: 'basic',
                active: false,
                link: '/villuathugun/xml-xsd',
                disabled: true,
                meta: {
                    hide: true,
                    roles: [USER_ROLES.VALIDATION_CHECK_XML_XSD],
                },
            },
        ],
    },
    {
        id: 'document-center',
        type: 'basic',
        link: '/skjalasafn',
        meta: {
            hide: false,
            roles: [USER_ROLES.UPLOAD_DOCUMENTS, USER_ROLES.DOCUMENT_CENTER_SUPERUSER, USER_ROLES.DOCUMENT_ACCESS_FILES_WITH_DIVISION],
        },
    },
    {
        id: 'it',
        type: 'collapsable',
        children: [
            {
                id: 'it.azure-environment-reservations',
                type: 'basic',
                link: '/it/fratektir-azure-umhverfa',
                meta: {
                    hide: true,
                    roles: [USER_ROLES.AZURE_ENVIRONMENT_RESERVATIONS],
                },
            },
        ],
        meta: {
            hide: true,
            roles: [USER_ROLES.AZURE_ENVIRONMENT_RESERVATIONS],
        },
    },
    {
        id: 'bakvordur',
        type: 'basic',
        link: '/bakvordur',
        meta: {
            hide: true,
            roles: [USER_ROLES.BAKVORDUR, USER_ROLES.BAKVORDUR_ADMIN],
        },
    },
];
